import { CmsApiFormBuilderBlockData } from 'modules/cms/api/types/CmsApiFormBuilder';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAmpFormBuilderBlock } from './CmsAmpFormBuilderBlock';
import { CmsFormBuilderBlock } from './CmsFormBuilderBlock';

export const CmsFormBuilderBlockMapping: CmsBlockMapping<CmsApiFormBuilderBlockData> =
  {
    invariant: [],
    width: CmsBlockWidth.GRID,
    Component: CmsFormBuilderBlock,
    AmpComponent: CmsAmpFormBuilderBlock,
  };
